import React, { useEffect, useRef, useState } from 'react';
import {
  FaCalendarDays,
  FaTrophy,
  FaGift,
  FaHotel,
  FaUtensils,
  FaPenNib,
  FaChartLine,
  FaPrint,
  FaLaptopCode,
  FaArrowRight,
  FaArrowUpRightFromSquare,
  FaCheck,
  FaStar,
  FaPlay,
  FaXmark,
} from 'react-icons/fa6';

const servicesData = [
  {
    id: 1,
    icon: FaCalendarDays,
    tag: 'Planning & Execution',
    title: 'Event Management',
    shortTitle: 'Events',
    description:
      'Premium end-to-end event planning and execution for corporate events, weddings, conferences, exhibitions, product launches, and grand celebrations with creative themes.',
    features: ['Corporate Events', 'Weddings', 'Conferences', 'Exhibitions'],
    image:
      'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1511578314322-379afb476865?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=400&h=300&fit=crop&q=80',
    ],
    color: '#4f46e5',
    gradient: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
    projects: '120+',
    rating: 4.9,
  },
  {
    id: 2,
    icon: FaTrophy,
    tag: 'Recognition Awards',
    title: 'Memento & Trophy',
    shortTitle: 'Trophies',
    description:
      'Elegant custom trophies, mementos, shields, medals, and awards crafted with precision for corporate recognition, sports events, and special occasions.',
    features: ['Custom Trophies', 'Medals & Shields', 'Awards', 'Plaques'],
    image:
      'https://images.unsplash.com/photo-1567427018141-0584cfcbf1b8?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1578269174936-2709b6aeb913?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1532635241-17e820acc59f?w=400&h=300&fit=crop&q=80',
    ],
    color: '#f59e0b',
    gradient: 'linear-gradient(135deg, #f59e0b, #d97706)',
    projects: '500+',
    rating: 4.8,
  },
  {
    id: 3,
    icon: FaGift,
    tag: 'Brand Gifting',
    title: 'Corporate Gifts',
    shortTitle: 'Gifts',
    description:
      'Curated corporate gifting solutions including branded merchandise, executive gifts, festival hampers, and customized promotional products.',
    features: [
      'Branded Merch',
      'Executive Gifts',
      'Festival Hampers',
      'Promo Items',
    ],
    image:
      'https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=400&h=300&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1513885535751-8b9238bd345a?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1512909006721-3d6018887383?w=400&h=300&fit=crop&q=80',
    ],
    color: '#ef4444',
    gradient: 'linear-gradient(135deg, #ef4444, #dc2626)',
    projects: '300+',
    rating: 4.9,
  },
  
  {
    id: 4,
    icon: FaHotel,
    tag: 'Guest Excellence',
    title: 'Hospitality Management',
    shortTitle: 'Hospitality',
    description:
      'Complete hospitality solutions including hotel management, guest services, banquet operations, and premium hospitality staffing for seamless experiences.',
    features: [
      'Hotel Management',
      'Guest Services',
      'Banquet Ops',
      'Staffing',
    ],
    image:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=400&h=300&fit=crop&q=80',
    ],
    color: '#10b981',
    gradient: 'linear-gradient(135deg, #10b981, #059669)',
    projects: '80+',
    rating: 4.7,
  },
  {
    id: 5,
    icon: FaUtensils,
    tag: 'Operations Support',
    title: 'Industrial Catering & Facility',
    shortTitle: 'Catering',
    description:
      'Large-scale industrial catering, housekeeping, pantry services, and complete facility management for corporates, factories, and institutions.',
    features: [
      'Bulk Catering',
      'Housekeeping',
      'Pantry Service',
      'Facility Mgmt',
    ],
    image:
      'https://images.unsplash.com/photo-1555244162-803834f70033?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1567521464027-f127ff144326?w=400&h=300&fit=crop&q=80',
    ],
    color: '#8b5cf6',
    gradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    projects: '150+',
    rating: 4.8,
  },
  {
    id: 6,
    icon: FaPenNib,
    tag: 'Visual Identity',
    title: 'Graphic Design',
    shortTitle: 'Design',
    description:
      'Creative branding, logo design, social media creatives, brochures, packaging, and visual identity systems that elevate your brand.',
    features: ['Logo Design', 'Branding', 'Social Media', 'Packaging'],
    image:
      'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?w=400&h=300&fit=crop&q=80',
    ],
    color: '#ec4899',
    gradient: 'linear-gradient(135deg, #ec4899, #db2777)',
    projects: '400+',
    rating: 4.9,
  },
  {
    id: 7,
    icon: FaChartLine,
    tag: 'Growth Strategy',
    title: 'Business Consultant',
    shortTitle: 'Consulting',
    description:
      'Strategic business consulting for market analysis, growth strategy, operational efficiency, financial planning, and business transformation.',
    features: [
      'Market Analysis',
      'Growth Plans',
      'Financial Advisory',
      'Operations',
    ],
    image:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1591696205602-2f950c417cb9?w=400&h=300&fit=crop&q=80',
    ],
    color: '#06b6d4',
    gradient: 'linear-gradient(135deg, #06b6d4, #0891b2)',
    projects: '90+',
    rating: 4.7,
  },
  {
    id: 8,
    icon: FaPrint,
    tag: 'Procurement',
    title: 'Government Stationery Supplier',
    shortTitle: 'Stationery',
    description:
      'Authorized supplier of office stationery, printing materials, IT peripherals, and essential supplies with GeM portal compliance.',
    features: [
      'Office Supplies',
      'Print Material',
      'IT Peripherals',
      'GeM Portal',
    ],
    image:
      'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=400&h=300&fit=crop&q=80',
    ],
    color: '#f97316',
    gradient: 'linear-gradient(135deg, #f97316, #ea580c)',
    projects: '200+',
    rating: 4.6,
  },
  {
    id: 9,
    icon: FaLaptopCode,
    tag: 'Digital Products',
    title: 'Software Development',
    shortTitle: 'Software',
    description:
      'Modern web applications, mobile apps, enterprise software, APIs, dashboards, and full-stack SaaS development tailored to your needs.',
    features: ['Web Apps', 'Mobile Apps', 'SaaS Products', 'APIs'],
    image:
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=300&fit=crop&q=80',
      'https://images.unsplash.com/photo-1605379399642-870262d3d051?w=400&h=300&fit=crop&q=80',
    ],
    color: '#3b82f6',
    gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    projects: '180+',
    rating: 4.9,
  },
];

/* ──────────────── Modal Component ──────────────── */
const ServiceModal = ({ service, onClose }) => {
  if (!service) return null;
  const Icon = service.icon;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <FaXmark />
        </button>

        {/* Hero Image */}
        <div className="modal-hero">
          <img src={service.image} alt={service.title} />
          <div className="modal-hero-overlay" style={{ background: service.gradient }}>
            <div className="modal-hero-badge">
              <Icon /> {service.tag}
            </div>
            <h2>{service.title}</h2>
          </div>
        </div>

        {/* Body */}
        <div className="modal-body">
          <div className="modal-info-row">
            <div className="modal-stat-chip">
              <FaStar style={{ color: '#f59e0b' }} />
              <span>{service.rating} Rating</span>
            </div>
            <div className="modal-stat-chip">
              <FaCheck style={{ color: '#10b981' }} />
              <span>{service.projects} Projects</span>
            </div>
          </div>

          <p className="modal-desc">{service.description}</p>

          <h4>What We Offer</h4>
          <div className="modal-features-grid">
            {service.features.map((f, i) => (
              <div className="modal-feature-item" key={i}>
                <FaCheck style={{ color: service.color }} />
                <span>{f}</span>
              </div>
            ))}
          </div>

          <h4>Our Work</h4>
          <div className="modal-gallery">
            {service.gallery.map((img, i) => (
              <div className="modal-gallery-item" key={i}>
                <img src={img} alt={`${service.title} work ${i + 1}`} />
              </div>
            ))}
          </div>

          <a href="#contact" className="modal-cta" style={{ background: service.gradient }} onClick={onClose}>
            Get a Free Quote <FaArrowRight />
          </a>
        </div>
      </div>
    </div>
  );
};

/* ──────────────── Main Services Component ──────────────── */
const Services = () => {
  const cardsRef = useRef([]);
  const [selectedService, setSelectedService] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { key: 'all', label: 'All Services' },
    { key: 'events', label: 'Events & Hospitality', ids: [1, 4, 5] },
    { key: 'creative', label: 'Creative & Design', ids: [2, 3, 6] },
    { key: 'business', label: 'Business & Tech', ids: [7, 8, 9] },
  ];

  const filteredServices =
    activeFilter === 'all'
      ? servicesData
      : servicesData.filter((s) =>
          filters.find((f) => f.key === activeFilter)?.ids.includes(s.id)
        );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, [filteredServices]);

  // Lock scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = selectedService ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedService]);

  /* ───── Featured service (first) ───── */
  const featured = servicesData[0];
  const FeaturedIcon = featured.icon;

  return (
    <section className="srv" id="services">
      <div className="srv-container">
        {/* ── Section Header ── */}
        <div className="srv-header">
          <span className="srv-badge">Our Expertise</span>
          <h2>
            Professional Services <br />
            <span className="srv-gradient-text">Built for Modern Business</span>
          </h2>
          <p>
            We deliver polished, reliable and high-impact solutions across events,
            branding, hospitality, consulting, procurement and technology.
          </p>
        </div>

        {/* ── Featured Service (big card) ── */}
        <div
          className="srv-featured"
          onClick={() => setSelectedService(featured)}
        >
          <div className="srv-featured-img">
            <img src={featured.image} alt={featured.title} />
            <div className="srv-featured-play">
              <FaPlay />
            </div>
          </div>

          <div className="srv-featured-content">
            <div className="srv-featured-top">
              <div
                className="srv-featured-icon"
                style={{ background: featured.gradient }}
              >
                <FeaturedIcon />
              </div>
              <span
                className="srv-featured-tag"
                style={{ color: featured.color }}
              >
                {featured.tag}
              </span>
            </div>

            <h3>{featured.title}</h3>
            <p>{featured.description}</p>

            <div className="srv-featured-features">
              {featured.features.map((f, i) => (
                <span key={i}>
                  <FaCheck /> {f}
                </span>
              ))}
            </div>

            <div className="srv-featured-bottom">
              <div className="srv-featured-stats">
                <div>
                  <strong>{featured.projects}</strong>
                  <span>Projects</span>
                </div>
                <div>
                  <strong>{featured.rating}</strong>
                  <span>Rating</span>
                </div>
              </div>
              <button
                className="srv-featured-btn"
                style={{ background: featured.gradient }}
              >
                Explore Service <FaArrowRight />
              </button>
            </div>
          </div>
        </div>

        {/* ── Filter Tabs ── */}
        <div className="srv-filters">
          {filters.map((f) => (
            <button
              key={f.key}
              className={`srv-filter-btn ${activeFilter === f.key ? 'active' : ''}`}
              onClick={() => setActiveFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* ── Grid of cards ── */}
        <div className="srv-grid">
          {filteredServices.map((service, index) => {
            const Icon = service.icon;
            return (
              <article
                className="srv-card fade-in"
                key={service.id}
                ref={(el) => (cardsRef.current[index] = el)}
                style={{
                  '--accent': service.color,
                  '--grad': service.gradient,
                  transitionDelay: `${index * 0.08}s`,
                }}
                onClick={() => setSelectedService(service)}
              >
                {/* Image */}
                <div className="srv-card-img">
                  <img src={service.image} alt={service.title} loading="lazy" />
                  <div className="srv-card-img-overlay">
                    <span>
                      <FaArrowUpRightFromSquare /> View Details
                    </span>
                  </div>
                  <div className="srv-card-number">
                    {String(service.id).padStart(2, '0')}
                  </div>
                </div>

                {/* Body */}
                <div className="srv-card-body">
                  <div className="srv-card-head">
                    <div
                      className="srv-card-icon"
                      style={{
                        background: `${service.color}15`,
                        color: service.color,
                      }}
                    >
                      <Icon />
                    </div>
                    <span className="srv-card-tag">{service.tag}</span>
                  </div>

                  <h3>{service.title}</h3>
                  <p>{service.description}</p>

                  {/* Mini gallery */}
                  <div className="srv-card-gallery">
                    {service.gallery.map((img, i) => (
                      <div className="srv-card-gallery-thumb" key={i}>
                        <img
                          src={img}
                          alt={`${service.title} ${i + 1}`}
                          loading="lazy"
                        />
                      </div>
                    ))}
                    <div className="srv-card-gallery-more">+</div>
                  </div>

                  <div className="srv-card-footer">
                    <div className="srv-card-meta">
                      <span>
                        <FaStar style={{ color: '#f59e0b' }} />{' '}
                        {service.rating}
                      </span>
                      <span>•</span>
                      <span>{service.projects} Done</span>
                    </div>
                    <span className="srv-card-link" style={{ color: service.color }}>
                      Details <FaArrowRight />
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>

      {/* ── Modal ── */}
      {selectedService && (
        <ServiceModal
          service={selectedService}
          onClose={() => setSelectedService(null)}
        />
      )}
    </section>
  );
};

export default Services;